import type { VerifyParams } from './verifyUrl';

const BASE = 'https://ebrs.moic.gov.la/api/pub/PrintoutQRCodeVerification/verify';
const TIMEOUT_MS = 15_000;

/** Only the fields this feature reads. The registry sends more — the registered
 *  address, the enterprise type — as GUIDs needing a second lookup we don't make. */
export interface VerifyResponse {
  CurrentData?: {
    RegistrationObjectInfo?: { RegistrationObjectNumber?: string | null } | null;
    BusinessEntity?: { NameLao?: string | null; NameEnglish?: string | null } | null;
  } | null;
  IsSignatureValid?: boolean;
  UpdatedDataExists?: boolean;
  ErrorText?: string | null;
}

/** Ask the MOIC registry to verify a certificate and hand back what it says.
 *
 *  Deliberately not the project's `api` helper: that one attaches the session
 *  cookie and redirects to /login on any 401, so a 401 from this foreign host
 *  would sign the operator out of the console. Sending no credentials and no
 *  extra headers also keeps this a CORS simple request — no preflight, which the
 *  registry does not answer.
 */
export async function verifyCertificate(
  p: VerifyParams,
  signal: AbortSignal = AbortSignal.timeout(TIMEOUT_MS),
): Promise<VerifyResponse> {
  const path = [p.roId, p.id, p.sig].map(encodeURIComponent).join('/');
  const res = await fetch(`${BASE}/${path}`, { credentials: 'omit', signal });
  if (!res.ok) throw new Error(`moic verify ${res.status}`);
  return (await res.json()) as VerifyResponse;
}
